import { useState } from "react";
import { Link } from "react-router-dom";
import { Radio, ChevronDown, X } from "lucide-react";

const SPOTIFY_PLAYLIST_ID = "0Z4ZR8MGvVOIvWnVHZFFqB";

export default function RadioBar() {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    try {
      return sessionStorage.getItem("pfc_radio_dismissed") === "1";
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  return (
    <div
      className="sticky top-[64px] z-40 bg-ink-900/95 backdrop-blur border-b border-pfc-gold/20"
      data-testid="radio-bar"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-2.5 flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 shrink-0">
          <Radio className="text-pfc-gold animate-pulse" size={14} />
          <span className="font-sub uppercase tracking-[0.25em] text-[10px] text-pfc-gold">
            PFC Hitlist Radio
          </span>
          <span className="hidden sm:inline-flex items-center gap-1 px-1.5 py-0.5 bg-pfc-red/15 border border-pfc-red/30">
            <span className="w-1 h-1 bg-pfc-red rounded-full animate-pulse" />
            <span className="font-sub text-[9px] uppercase tracking-[0.25em] text-pfc-red">ON AIR</span>
          </span>
        </div>
        <button
          onClick={() => setOpen(!open)}
          className="font-sub uppercase tracking-[0.2em] text-[10px] text-white/80 hover:text-pfc-gold transition flex items-center gap-1.5"
          data-testid="radio-bar-toggle"
        >
          {open ? "Hide Player" : "▶ Press Play to Listen"}
          <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        <Link
          to="/radio"
          className="font-sub uppercase tracking-[0.2em] text-[10px] text-pfc-gold/80 hover:text-pfc-gold transition ml-auto"
          data-testid="radio-bar-link"
        >
          Radio Station →
        </Link>
        <button
          onClick={() => {
            try { sessionStorage.setItem("pfc_radio_dismissed", "1"); } catch (_) {}
            setDismissed(true);
          }}
          className="text-white/40 hover:text-white p-1"
          aria-label="Dismiss radio bar for this session"
          data-testid="radio-bar-dismiss"
        >
          <X size={12} />
        </button>
      </div>
      {open && (
        <div className="bg-ink-800 border-t border-white/5" data-testid="radio-bar-player">
          <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-3">
            <iframe
              title="PFC Hitlist Radio · Site-wide Player"
              src={`https://open.spotify.com/embed/playlist/${SPOTIFY_PLAYLIST_ID}?utm_source=generator&theme=0`}
              width="100%"
              height="152"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              style={{ borderRadius: 8 }}
            />
            <p className="text-white/40 font-body text-[11px] mt-2 text-center">
              Player not loading?{" "}
              <a
                href={`https://open.spotify.com/playlist/${SPOTIFY_PLAYLIST_ID}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-pfc-gold hover:underline"
              >
                Open in Spotify
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
